import React from "react";
import { Container, Accordion } from "react-bootstrap";
import {
  FaEnvelope,
  FaInstagram,
  FaWhatsapp,
  FaMapMarkerAlt,
  FaCar,
  FaHotel,
  FaCopyright,
  FaExclamationTriangle,
  FaDollarSign,
} from "react-icons/fa";

function InfoPage() {
  return (
    <Container>
      <h2>Información Relevante</h2>
      <p>
        Aquí encontrarás detalles importantes sobre el evento y los datos que
        manejamos.
      </p>

      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          {" "}
          {/* Ubicación de la Pista */}
          <Accordion.Header>
            <FaMapMarkerAlt className="me-2" /> Ubicación de la Pista
          </Accordion.Header>
          <Accordion.Body>
            Encuentra la ubicación exacta de la pista de competición en Google
            Maps:{" "}
            <a
              href="https://maps.app.goo.gl/fEpZiQFXTBhyEwv28"
              target="_blank"
              rel="noopener noreferrer"
            >
              Ver en Google Maps
            </a>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="1">
          {" "}
          {/* Datos de Arriendo Vehículos */}
          <Accordion.Header>
            <FaCar className="me-2" /> Datos de Arriendo Vehículos
          </Accordion.Header>
          <Accordion.Body>
            <a
              href="https://www.chileanrentacar.cl/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.chileanrentacar.cl/
            </a>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="2">
          {" "}
          {/* Búsqueda de Hoteles */}
          <Accordion.Header>
            <FaHotel className="me-2" /> Búsqueda de Hoteles en Calama
          </Accordion.Header>
          <Accordion.Body>
            <a
              href="https://www.trivago.cl/es-CL/lm?themeId=1&search=200-81680&sem_keyword=hoteles%20calama&sem_creativeid=719865571842&sem_matchtype=e&sem_network=g&sem_device=c&sem_placement=&sem_target=&sem_adposition=&sem_param1=&sem_param2=&sem_campaignid=17280219330&sem_adgroupid=135542685486&sem_targetid=kwd-1600357050&sem_location=9048034&cipc=sem&cip=5619001825&gad_source=1&gad_campaignid=17280219330&gbraid=0AAAAAD6-gN_FBOgC7k-SCvKrQdHdDTITW&gclid=CjwKCAjw-8vPBhBbEiwAoA39WsAXcLnUvpWmjepvKXMnZJvnxdBrp4gnBNyZEqGWgHEiirpn-mbpfhoCjM0QAvD_BwE/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.trivago.cl/
            </a>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="3">
          {/* Valores de Inscripción */}
          <Accordion.Header>
            <FaDollarSign className="me-2" /> Valores de Inscripción
          </Accordion.Header>
          <Accordion.Body>
            <p>
              Los costos de inscripción para participar en el evento son los
              siguientes:
            </p>
            <ul>
              <li>
                <strong>Inscripción base (1 categoría):</strong> USD 100
              </li>
              <li>
                <strong>Inscripción en 2 categorías:</strong> USD 150
              </li>
              <li>
                <strong>Inscripción en 3 categorías:</strong> USD 150
              </li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="4">
          {" "}
          {/* Información de Contacto Agrupada */}
          <Accordion.Header>
            <FaEnvelope className="me-2" /> Contacto del Evento
          </Accordion.Header>
          <Accordion.Body>
            <p className="mb-2">
              <FaEnvelope className="me-2 text-primary" />{" "}
              <strong>Email:</strong>{" "}
              <a
                href="mailto:contacto@sudamrc2027.cl"
                target="_blank"
                rel="noopener noreferrer"
              >
                contacto@sudamrc2027.cl
              </a>
            </p>
            <p className="mb-2">
              <FaInstagram className="me-2 text-danger" />{" "}
              <strong>Instagram:</strong>{" "}
              <a
                href="https://www.instagram.com/sudamrc2027"
                target="_blank"
                rel="noopener noreferrer"
              >
                @sudam2027
              </a>
            </p>
            <p className="mb-0">
              <FaWhatsapp className="me-2 text-success" />{" "}
              <strong>WhatsApp:</strong>{" "}
              <a
                href="https://wa.me/56912345678"
                target="_blank"
                rel="noopener noreferrer"
              >
                +56 9 (Click para contactar)
              </a>
            </p>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="5">
          {" "}
          {/* Propiedad Intelectual */}
          <Accordion.Header>
            <FaCopyright className="me-2" /> Propiedad Intelectual
          </Accordion.Header>
          <Accordion.Body>
            Todo el contenido presente en este sitio, incluyendo logotipos,
            textos, el diseño del afiche oficial y las fotografías de la galería
            (registros históricos de 2019), son propiedad exclusiva de la
            organización Sudam 2027 o de sus respectivos autores. Queda
            estrictamente prohibida su reproducción o uso comercial sin
            autorización previa.
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="6">
          {" "}
          {/* Descargo de Responsabilidad */}
          <Accordion.Header>
            <FaExclamationTriangle className="me-2" /> Descargo de
            Responsabilidad
          </Accordion.Header>
          <Accordion.Body>
            La organización del Sudamericano 2027 se reserva el derecho de
            realizar cambios en el cronograma, reglamentación técnica o
            ubicación del evento por razones de fuerza mayor. Cualquier
            actualización será comunicada oportunamente a través de nuestros
            canales oficiales.
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </Container>
  );
}

export default InfoPage;
